<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dXPWF9/tc-custom/9781780107394.jpg?1736619087547" alt="This image is the cover for the book Cold Florida, The Foggy Moskowitz Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cold Florida, The Foggy Moskowitz Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A wisecracking former car thief turns amateur sleuth in this “appealing, offbeat” thriller series debut from an Edgar Award–winning author (<i>Booklist</i>).</b><br/>  <br/> It’s 1974. Foggy Moskowitz, once a Jewish car thief on the run from the Brooklyn authorities, is now in Florida working for Child Protective Services. For personal reasons.<br/>  <br/> An unlikely but tenacious child protection officer, he’s investigating the case of a missing infant taken from the hospital by her addict mother. But the case takes several unexpected turns—including a vision quest—as Foggy journeys from seedy Fry’s Bay to Indian Seminole swampland. Along the way he encounters more than a few interesting characters, including John Horse, an Indian mystic, and works to foil a vast land-grab scam by an uber-rich felon.<br/>  <br/> By turns amusing and moving, mixing passion with pathos, and introducing some truly colorful characters, <i>Cold Florida </i>is the first in an irreverent mystery series from the acclaimed author of the Fever Devlin novels.<br/>  <br/> “DePoy’s lively mix of Seminole history and the wry observations of a ‘Yankee Jew criminal’ make for an amusing tale.”<b> —</b><i>Publishers Weekly</i><br/>  <br/> “Those who are able to roll with Foggy will get an unholy kick out of the characters’ flexible allegiances and the hero’s colorful descriptions.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Phillip DePoy
      </h2>
      
      <p class="authorDescription body article">Phillip DePoy is the Edgar award-winning author of thirteen novels, including the Flap Tucker and Fever Devilin series, thirty-seven plays and several works of non-fiction. He has served as artistic director for professional theatre companies and several university theatre programmes.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05669c1a